import { useNavigate } from 'react-router-dom';
import { useMyAvatars } from './useAvatarCollection';
import AvatarCard from './AvatarCard';
import './gallery.css';

export default function AvatarCollectionPage() {
  const navigate = useNavigate();
  const { data: avatars, isLoading } = useMyAvatars();

  if (isLoading) {
    return (
      <div className="malpedia-gallery-page">
        <div className="malpedia-gallery-loading">Loading...</div>
      </div>
    );
  }

  return (
    <div className="malpedia-gallery-page">
      <div className="malpedia-gallery-header">
        <div className="malpedia-gallery-header-left">
          <h1 className="malpedia-gallery-title">My Avatars</h1>
          <span className="malpedia-gallery-subtitle">
            {avatars?.length ?? 0} / 50
          </span>
        </div>
        <button
          className="malpedia-avatar-btn malpedia-avatar-btn--primary"
          onClick={() => navigate('/avatar')}
        >
          Create New
        </button>
      </div>

      {!avatars?.length ? (
        <div className="malpedia-gallery-empty">
          <span className="malpedia-gallery-empty-icon">{'\uD83C\uDFA8'}</span>
          <p>No avatars yet. Create your first one!</p>
          <button
            className="malpedia-avatar-btn malpedia-avatar-btn--primary"
            onClick={() => navigate('/avatar')}
          >
            Create Avatar
          </button>
        </div>
      ) : (
        <div className="malpedia-gallery-grid">
          {avatars.map((a) => (
            <AvatarCard key={a.id} avatar={a} isOwner />
          ))}
        </div>
      )}
    </div>
  );
}
